import { BaseModel, BaseModelWoId } from './base.model';

export type FlatennedModel<T extends BaseModel | BaseModelWoId> = {
  [K in keyof T]: T[K] extends BaseModel
    ? string
    : T[K] extends Array<BaseModel>
    ? string[]
    : T[K];
};

export function flattenModel<T extends BaseModel | BaseModelWoId>(
  model: T | null | undefined,
): FlatennedModel<T> {
  if (!model) {
    return {} as FlatennedModel<T>;
  }

  const flatModel = { ...model } as Record<string, unknown>;

  for (const key in flatModel) {
    const value = flatModel[key];
    if (value instanceof BaseModel) {
      flatModel[key] = value.id;
    } else if (Array.isArray(value)) {
      flatModel[key] = value.map((v) => (v instanceof BaseModel ? v.id : v));
    }
  }

  return flatModel as FlatennedModel<T>;
}
